import { SanityAnnualReturnsTable, SanityAnnualReturnsTableData } from 'types/annual-returns';
import { AnnualReturnsTableData } from '@sanity/graphql/queries/annual-returns-table-data';
import { useQuery } from 'villus';
import { villusClient } from '@utils/villus';

export async function getAnnualReturnsTableData(): Promise<SanityAnnualReturnsTable | null> {
	const { data } = await useQuery<SanityAnnualReturnsTableData>({
		client: villusClient,
		query: AnnualReturnsTableData
	}).execute();

	return data?.allAnnualReturnsTable[0] ?? null;
}
